import { render } from "./SearchHistoryIcon.vue?vue&type=template&id=39fdfad5"
const script = {}
script.render = render

export default script